import { ShippingCost } from '../../../../interfaces/shippingCosts'
import { apiBffMobileV1ShippingCost } from './api'

export const getShippingCostByProviderId = async (providerId: string): Promise<ShippingCost[]> => {
  const response = await apiBffMobileV1ShippingCost.get(`/?idsProviders=${providerId}`)

  return response.data[providerId]['shippingCost'] ? response.data[providerId]['shippingCost']['costs'] : []
}
